<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0 d-flex align-items-center">
        <h5 class="card-title font-bold mb-0">
          جزئیات عملیات
        </h5>

        <div class="flex-grow-1"></div>

        <Back />
      </div>

      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <span class="spinner-border spinner-border-sm"></span>
          <span class="mr-2">در حال دریافت اطلاعات...</span>
        </div>

        <template v-else-if="action.id">
          <!-- اطلاعات عملیات -->
          <div class="row action-info">
            <div class="col-md-4 mb-3">
              <strong>عنوان:</strong>
              <span>{{ action.title || "—" }}</span>
            </div>

            <div class="col-md-4 mb-3">
              <strong>سطح:</strong>
              <span>
                {{ action.level ? action.level.title : "—" }}
              </span>
            </div>

            <div class="col-md-4 mb-3">
              <strong>حداقل مبلغ سبد خرید (تومان):</strong>
              <span>
                {{ action.min_order_amount ? ( action.min_order_amount | price ) : "—" }}
              </span>
            </div>

            <div class="col-md-4 mb-3">
              <strong>نوع عملیات:</strong>
              <span>{{ actionType }}</span>
            </div>

            <div class="col-md-4 mb-3">
              <strong>مبلغ:</strong>
              <span>
                {{ action.type_value || 0 | price }} تومان
              </span>
            </div>

            <div class="col-md-4 mb-3">
              <strong>تاریخ شروع:</strong>
              <span>
                {{
                  action.start_date
                    ? $options.filters.persianDate(action.start_date)
                    : "—"
                }}
              </span>
            </div>

            <div class="col-md-4 mb-3">
              <strong>تاریخ پایان:</strong>
              <span>
                {{
                  action.end_date
                    ? $options.filters.persianDate(action.end_date)
                    : "—"
                }}
              </span>
            </div>
          </div>

          <!-- جدول مشتریان -->
          <div class="mt-4">
            <h6 class="bg-light text-center rounded py-2 font-bold">
              مشتریان عملیات
            </h6>

            <b-table
              v-if="customers.length"
              hover
              bordered
              responsive
              show-empty
              :items="customers"
              :fields="fields"
            >
              <template v-slot:cell(customer)="data">
                <div>
                  <strong>
                    {{ customerName(data.item.customer) }}
                  </strong>

                  <small class="d-block text-muted">
                    شناسه: {{ data.item.customer_id }}
                  </small>
                </div>
              </template>

              <template v-slot:cell(mobile)="data">
                {{
                  data.item.customer
                    ? data.item.customer.mobile
                    : "—"
                }}
              </template>

              <template v-slot:cell(gift_balance)="data">
                {{ data.item.gift_balance || 0 | price }}
                تومان
              </template>

              <template v-slot:cell(used_gift_balance)="data">
                {{ data.item.used_gift_balance || 0 | price }}
                تومان
              </template>

              <template v-slot:cell(remaining_balance)="data">
                {{ remainingBalance(data.item) | price }}
                تومان
              </template>

              <template v-slot:cell(status)="data">
                <span
                  class="badge"
                  :class="
                    data.item.start_finished
                      ? 'badge-success'
                      : 'badge-warning'
                  "
                >
                  {{
                    data.item.start_finished
                      ? "انجام شده"
                      : "در انتظار"
                  }}
                </span>
              </template>
            </b-table>

            <div v-else class="alert alert-warning">
              مشتری‌ای برای این عملیات ثبت نشده است.
            </div>

            <pagination
              v-if="customerActions.last_page > 1"
              :disabled="disabled"
              :limit="2"
              :data="customerActions"
              @pagination-change-page="changePage"
            />
          </div>
        </template>

        <div v-else class="alert alert-danger">
          اطلاعات عملیات پیدا نشد.
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ActionShowImpl from "@@/core/pages/Action/ActionShowImpl";

export default {
  extends: ActionShowImpl,
};
</script>

<style scoped>
.action-info {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 6px;
}

.action-info strong {
  margin-left: 6px;
}

.table-responsive {
  height: auto;
}
</style>